<div class="delivery-all-ventures-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="allVentures()"></grid-content>
</div>